import { createContext, useCallback, useContext, useEffect, useId, useState } from 'react';
import './SearchLoading.css';

const SearchActivityContext = createContext(null);
export const SearchResultPanelContext = createContext(true);

export const SearchActivityProvider = ({ children }) => {
    const [loadingRequests, setLoadingRequests] = useState(() => new Set());
    const reportLoading = useCallback((id, loading) => {
        setLoadingRequests(current => {
            if (current.has(id) === loading) return current;
            const next = new Set(current);
            if (loading) next.add(id);
            else next.delete(id);
            return next;
        });
    }, []);

    return (
        <SearchActivityContext.Provider value={{ reportLoading, isLoading: loadingRequests.size > 0 }}>
            {children}
        </SearchActivityContext.Provider>
    );
};

// Previously visited categories can finish their requests in the background;
// only the visible category shows activity beside the query.
export const useSearchResultLoading = () => {
    const activity = useContext(SearchActivityContext);
    const isActivePanel = useContext(SearchResultPanelContext);
    const id = useId();
    const reportLoading = activity?.reportLoading;

    useEffect(() => {
        if (!reportLoading || !isActivePanel) return;
        reportLoading(id, true);
        return () => reportLoading(id, false);
    }, [id, isActivePanel, reportLoading]);
};

export const SearchBoxActivity = ({ children }) => {
    const isLoading = useContext(SearchActivityContext)?.isLoading ?? false;

    return (
        <div className='searchBoxActivity' data-search-loading={isLoading}>
            {children}
            {isLoading && <>
                <span className='searchBoxActivityIndicator' aria-hidden='true' />
                <span className='visuallyHidden' role='status'>Searching</span>
            </>}
        </div>
    );
};
